/**
 * 관리자 홈 화면.
 */
import { DataCard } from '@/shared/components/DataCard';
import { PageHeader } from '@/shared/components/PageHeader';
import { CardContent, CardHeader, CardTitle } from '@/shared/components/ui/card';
import { ROUTE_PATHS } from '@/shared/constants/routes';
import { Link } from '@tanstack/react-router';
import {
  ArrowRight,
  Building2,
  Handshake,
  LayoutDashboard,
  Pill,
  Store,
  Users,
} from 'lucide-react';
import React from 'react';

const quickLinks = [
  { to: ROUTE_PATHS.INSTITUTIONS, label: '병의원', icon: Building2, desc: '병·의원 마스터' },
  { to: ROUTE_PATHS.PHARMACIES, label: '문전약국', icon: Store, desc: '약국 정보' },
  { to: ROUTE_PATHS.PHARMA_COMPANIES, label: '제약사', icon: Building2, desc: '제약사 관리' },
  { to: ROUTE_PATHS.DRUGS, label: '의약품', icon: Pill, desc: '의약품 목록' },
  { to: ROUTE_PATHS.USERS, label: '사용자', icon: Users, desc: '플랫폼 사용자' },
  { to: ROUTE_PATHS.CLIENTS, label: '거래처', icon: Handshake, desc: '거래처 관리' },
] as const;

export const DashboardPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        icon={LayoutDashboard}
        title="관리자 홈"
        description="RUDALINK 관리자 시스템에 오신 것을 환영합니다."
      />

      <DataCard>
        <CardHeader>
          <CardTitle>빠른 이동</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {quickLinks.map(({ to, label, icon: Icon, desc }) => (
              <Link
                key={to}
                to={to as never}
                className="group flex items-center gap-3 rounded-lg border border-primary/10 bg-card p-4 transition-all hover:border-primary/30 hover:bg-primary/[0.04] hover:shadow-sm hover:shadow-primary/5"
              >
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-primary/15 to-ruda-secondary/10 text-primary ring-1 ring-primary/20 transition-colors group-hover:from-primary group-hover:to-ruda-secondary group-hover:text-white group-hover:ring-0">
                  <Icon className="h-4 w-4" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="font-medium">{label}</div>
                  <div className="text-xs text-muted-foreground">{desc}</div>
                </div>
                <ArrowRight className="h-4 w-4 shrink-0 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" />
              </Link>
            ))}
          </div>
        </CardContent>
      </DataCard>
    </div>
  );
};
